import FormLead from "./formLead";
import { bullseyeTypeErrors, getQueryStringParam } from "../../utils";
import { useState } from "react";
import { Helmet } from "react-helmet-async";

const GoogleCaptchaKey = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;
// Get the query string from the current window location
const queryString = window.location.search;

// Extract the "ID" query string parameter
const qsFormId = getQueryStringParam(queryString, "ID");

const qsCountryId = getQueryStringParam(queryString, ["country", "countryid"]);
const countryId = parseInt(qsCountryId as string);

const qsLocationIds = getQueryStringParam(queryString, [
  "locationId",
  "locationIds",
  "locations",
]);
const locationIds = qsLocationIds?.split(",");

const LeadManagerForm = () => {
  const [contentBlock, setContentBlock] = useState({
    contentBlockEnabled: false,
    contentBlockContent: "",
  });

  const [advanceStyle, setAdvanceStyle] = useState({
    advancedStyleCSS: "",
    advancedStyleJS: "",
  });

  return (
    <div className="container-fluid bg-white">
      <div className="row m-0">
        {contentBlock.contentBlockEnabled && (
          <div className="col-5">
            <div
              className="w-100"
              dangerouslySetInnerHTML={{
                __html: contentBlock.contentBlockContent,
              }}
            ></div>
          </div>
        )}
        {/* You can delete or change the css class */}
        <div
          className={`leadManagerForm__container ${
            contentBlock.contentBlockEnabled ? "col-7" : "col-12"
          } `}
        >
          {/* Render the FormLead component */}
          <FormLead
            compact={false}
            formId={parseInt(qsFormId as string)}
            locationIds={locationIds}
            title={""}
            GoogleCaptchaKey={GoogleCaptchaKey}
            clientId={0}
            apiKey={""}
            selectedCountry={countryId && countryId > 0 ? countryId : null}
            interfaceId={""}
            setContentBlock={(
              contentBlockEnabled: boolean,
              contentBlockContent: string
            ) =>
              setContentBlock({
                contentBlockEnabled,
                contentBlockContent,
              })
            }
            onFormSubmit={() => {}}
            setAdvancedStyle={(
              advancedStyleCSS: string,
              advancedStyleJS: string
            ) => setAdvanceStyle({ advancedStyleCSS, advancedStyleJS })}
          />
        </div>
        <Helmet>
          <style>{`${advanceStyle.advancedStyleCSS}`}</style>
          <script>{`try { ${advanceStyle.advancedStyleJS} } catch (error) { error.issueType = "${bullseyeTypeErrors.advancedStyle}"; throw error; }`}</script>
        </Helmet>
      </div>
    </div>
  );
};

export default LeadManagerForm;
